var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-wrapper"},[_c('div',[_c('h1',{staticClass:"center pb-max pt-max",staticStyle:{"font-size":"24px"}},[_vm._v("\n      "+_vm._s(_vm.$t("dashboard.headers.no_tests"))+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8cb76f4a","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/dashboard/NoTests.vue
// module id = kfPJ
// module chunks = 0 1